import type React from 'react';

interface OverviewSectionCardProps {
    title: string;
    action?: React.ReactNode;
    children: React.ReactNode;
}

export function OverviewSectionCard({
    title,
    action,
    children,
}: OverviewSectionCardProps): React.ReactElement {
    return (
        <div className="rounded-xl border border-gray-200 bg-white shadow-sm">
            <div className="flex items-center justify-between border-b border-gray-200 px-4 py-6">
                <h2 className="text-lg text-gray-900">{title}</h2>
                {action}
            </div>
            {children}
        </div>
    );
}
